import { EmployeesChart } from "@/pages/employees/chart/EmployeesChart.tsx";
import { DepartmentsChart } from "@/pages/employees/departments-chart/DepartmentsChart.tsx";
import { EmployeePage } from "@/pages/employees/employee/EmployeePage.tsx";
import { HirePage } from "@/pages/employees/hire/HirePage.tsx";
import Employees from "@/pages/employees/index/Employees.tsx";
import TeamPage from "@/pages/employees/team/TeamPage.tsx";
import { EmployeeTimeOffsHistoryPage } from "@/pages/employees/time-off/EmployeeTimeOffsHistoryPage.tsx";
import { TimesheetsPage } from "@/pages/employees/time-tracking/TimesheetsPage.tsx";
import { EmployeeCustomTableRows } from "@/pages/settings/custom-fields/EmployeeCustomTableRows.tsx";
import { RouteConfig } from "@/routes/types/route.types.ts";
import { ApiPermission, EmployeeFieldPermission } from "@/types/role.types.ts";
import { ApiFeatureType } from "@/types/subscription.types.ts";

export const employeeRoutes: RouteConfig[] = [
  {
    path: "/employees",
    children: [
      {
        path: "",
        element: <Employees />,
        allOfPermissions: [ApiPermission.see_employee_directory],
      },
      {
        path: "chart",
        element: <EmployeesChart />,
        allOfEditFieldPermissions: [EmployeeFieldPermission.see_organization_structure],
      },
      {
        path: ":id/time-off-history",
        allOfPermissions: [ApiPermission.see_employee_directory],
        bypassSelfCheck: true,
        children: [
          { path: "", element: <EmployeeTimeOffsHistoryPage /> },
          { path: ":category_id", element: <EmployeeTimeOffsHistoryPage /> },
        ],
      },
      {
        path: ":id",
        element: <EmployeePage />,
        allOfPermissions: [ApiPermission.see_employee_directory],
        bypassSelfCheck: true,
      },
      {
        path: "hire",
        element: <HirePage />,
        isFullScreen: true,
        allOfPermissions: [ApiPermission.add_employees],
      },
      {
        path: ":id/:section",
        element: <EmployeePage />,
        allOfPermissions: [ApiPermission.see_employee_directory],
        bypassSelfCheck: true,
      },
      {
        path: "table/:table_slug/rows",
        element: <EmployeeCustomTableRows />,
        planFeature: ApiFeatureType.custom_fields,
      },
      {
        path: "teams",
        element: <TeamPage />,
        anyOfViewPermissions: [ApiPermission.manage_teams],
        children: [
          { path: "", element: <TeamPage /> },
          { path: ":id", element: <TeamPage /> },
          { path: ":id/:section", element: <TeamPage /> },
        ],
      },
      {
        path: "timesheets",
        element: <TimesheetsPage />,
        planFeature: ApiFeatureType.clocking,
      },
    ],
  },
  {
    path: "/departments/chart",
    allOfEditFieldPermissions: [EmployeeFieldPermission.see_departments_structure],
    element: <DepartmentsChart />,
  },
];
